import { render, staticRenderFns } from "./guruTerdaftar.vue?vue&type=template&id=646720fc"
import script from "./guruTerdaftar.vue?vue&type=script&lang=js"
export * from "./guruTerdaftar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports